import {AutoSave} from '@flinkit/ra-form-layout'
import {InputAdornment} from '@mui/material'
import {
  Create,
  Datagrid,
  EditButton,
  FilterLiveSearch,
  FunctionField,
  ReferenceManyCount,
  required,
  SaveButton,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  useGetIdentity,
  useTranslate,
} from 'react-admin'
import {makeStyles} from 'tss-react/mui'

import ExtendedEdit from '../components/ExtendedEdit'
import {ChevronRightIcon, SaveIcon, SearchIcon} from '../components/icons'
import {CompanySettingsTab} from '../pages/CompanySettingsPage'
import DeleteWithConfirmButton from './components/DeleteWithConfirmButton'
import ExtendedList from './components/ExtendedList'
import ExtendedPagination from './components/ExtendedPagination'
import {ShowHeader} from './components/ResourceHeader'

const TagsList = () => (
  <ExtendedList
    filters={[
      <FilterLiveSearch
        // @ts-ignore: 'InputProps' does not exist
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon color="secondary" />
            </InputAdornment>
          ),
          onKeyDown: e => {
            if (e.key === 'Enter') {
              e.preventDefault()
              e.stopPropagation()
            }
          },
        }}
        alwaysOn
        key="tageName"
        source={"name@_ilike"}
      />,
    ]}
    resource="tags"
    shouldAlignActionButtonsWithFilterForm
    sort={{field: 'name', order: 'ASC'}}
    title={false}
    pagination={<ExtendedPagination rowsPerPageOptions={[]} />}
    perPage={25}
  >
    <TagsDatagrid />
  </ExtendedList>
)

const TagsDatagrid = () => (
  <Datagrid bulkActionButtons={false}>
    <TextField source="name" />
    <FunctionField
      render={r => (
        <ReferenceManyCount
          filter={{tagId: r.id}}
          reference="merchant_customer_user_tags"
          sort={{field: 'tagId', order: 'ASC'}}
          target="tagId"
        />
      )}
      source="merchantCustomerUsersCount"
    />
    <EditButton
      icon={<ChevronRightIcon color="info" />}
      label=""
      // @ts-ignore
      source="editIconButton"
    />
  </Datagrid>
)

const TagEdit = () => (
  <ExtendedEdit
    actions={<ShowHeader title={useTranslate()('resources.tags.edit.title')} />}
    className={useStyles({}).classes.edit}
    resource="tags"
  >
    <SimpleForm
      resetOptions={{keepDirtyValues: true}}
      toolbar={(
        <AutoSave
          confirmationDuration={false}
          debounce={1000}
          typographyProps={{display: 'none'}}
        />
      )}
    >
      <TextInput source="name" validate={required()}/>
    </SimpleForm>
    <Toolbar>
      <DeleteWithConfirmButton
        confirmContent={useTranslate()('resources.tags.confirmDeletion')}
        confirmTitle={record => record.name}
        redirectTo={`/company-settings#${CompanySettingsTab.Tags}`}
      />
    </Toolbar>
  </ExtendedEdit>
)

const TagCreate = () => {
  const {identity: {merchantId} = {}} = useGetIdentity()
  return (
    <Create
      title="Create"
      actions={
        <ShowHeader
          title={useTranslate()('resources.tags.create.title')}
        />
      }
      resource="tags"
    >
      <SimpleForm
        defaultValues={{merchantId}}
        resetOptions={{keepDirtyValues: true}}
        toolbar={<CreateToolbar />}
      >
        <TextInput source="name" validate={required()}/>
      </SimpleForm>
    </Create>
  )
}

const CreateToolbar = () => (
  <Toolbar>
    <SaveButton color="primary" icon={<SaveIcon />} variant="contained" />
  </Toolbar>
)

const useStyles = makeStyles<any>()(theme => ({
  edit: {
    [theme.breakpoints.up('lg')]: {
      width: '50%',
    },
  },
}))

export {TagCreate, TagEdit, TagsList}
